import React, { useState } from "react"
import { FiArchive, FiArrowDown, FiBell, FiBellOff, FiCheck, FiChevronDown, FiFlag, FiImage, FiMenu, FiMic, FiMoreHorizontal, FiMoreVertical, FiPause, FiPhone, FiPlay, FiPlus, FiRepeat, FiSearch, FiSend, FiSmile, FiTrash, FiTrash2, FiUser, FiUsers, FiVideo, FiVolume, FiVolumeX, FiX, FiXOctagon } from "react-icons/fi"
import { neonUserGroups, neonUsers } from "../../../dummy/users"
import clx from "classnames"
import toast, { Toaster } from 'react-hot-toast';
import { neonMessages } from "../../../dummy/messages";
import { MentionRegex } from "../../../utils/helper";

const notify = () => toast.success('Here is your toast.');

export const RoomDetail = () => {
    return (
        <React.Fragment>
                
                <div
                className="detail col-span-2 bg-gray-100 dark:bg-[#1e2126] overflow-x-auto h-screen p-1"
                >
                {neonUserGroups.map((group,i)=>(
                <div>
                {group.name &&  <h3 className="text-gray-500 font-medium mx-4">{group.name}</h3> }
                <ul>
                    {group.list?.map((user,i)=>(
                    <li
                        className="hover:bg-gray-200 dark:hover:bg-gray-800 cursor-pointer mx-3"
                    >
                        <div className="flex gap-3 p-2 items-center">
                        <div className="relative">
                            {user.avatar && <img src={user.avatar} className="h-10" /> }
                            {!user.avatar && <React.Fragment>
                            <div 
                                style={{background:user.color}}
                                className="h-10 w-10 rounded-full text-2xl flex items-center justify-center pb-1 text-white">
                                {user.letter}
                            </div>
                            </React.Fragment> }
                            {user.type && (
                            <div
                            className={clx(
                                {'bg-green-500':user.type=='online'},
                                {'bg-red-500':user.type=='offline'},
                                {'bg-yellow-500':user.type=='busy'},
                                {'bg-gray-500':user.type=='afk'},
                                `absolute right-0 bottom-0 rounded-full h-3 w-3 border border-white border-2`
                            )}
                            ></div>
                            )}
                        </div>
                        <div className="">
                            <div className="flex">
                            <p style={{color:user.foreground}} >{user.name}</p>
                            {user.bot && (
                                <div
                                className="m-1 px-2 ml-2 text-xs bg-blue-500 text-white flex items-center justify-center rounded-full"
                                >
                                BOT
                                </div>
                            )}
                            </div>
                            <div className="text-gray-500 text-sm">{user.description}</div>
                        </div>
                        </div>
                        </li>
                    ))}
                    </ul>
                </div>
                ))}


                <h3 className="text-gray-400 font-medium mx-4">SHARED PHOTOS</h3>
                <div className="shared mx-4 items-center justify-center">
                <ul className="grid grid-cols-2 gap-2 mt-1">
                    {[
                    "/images/shared/Rectangle 3.png",
                    "/images/shared/Rectangle 4.png",
                    "/images/shared/Rectangle 5.png",
                    "/images/shared/Rectangle 6.png",
                    "/images/shared/Rectangle 7.png",
                    "/images/shared/Rectangle 8.png",
                    ].map((image,i)=>(
                    <li 
                    key={`image-${i}`}
                    className="rounded-md cursor-pointer">
                    <img
                        // @click="photo='/images/shared/Rectangle 3.png';preview=true"
                        src={image}
                        className="rounded-md h-24 w-full object-cover"
                    />
                    </li>
                    ))}
                    
                </ul>
                </div>
                </div>
        </React.Fragment>
    )
  }



